import { render, staticRenderFns } from "./government.vue?vue&type=template&id=7812b5ae&scoped=true&"
import script from "./government.vue?vue&type=script&lang=js&"
export * from "./government.vue?vue&type=script&lang=js&"
import style0 from "./government.vue?vue&type=style&index=0&id=7812b5ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812b5ae",
  null
  
)

export default component.exports